import { useRef, useCallback, useState, useMemo } from 'react';
import { Typography, Divider, Stack, Tab, Tabs } from '@mui/material';
import { usePageView } from 'src/hooks/use-page-view';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { SummaryOverview } from './infors/summary';
import { StatisticOverview } from './infors/statistic';
import { AssignedOverview } from './infors/assigned';
import PageSection from 'src/layouts/page-section';

const Page = ({ summary }) => {
  const rootRef = useRef(null);
  const { t } = useTranslation();

  usePageView();

  // Tabs configuration
  const tabs = useMemo(() => ([
    { label: `${summary?.month}`, value: 'summary', component: <SummaryOverview data={summary} /> },
    { label: t(appStr.txt_066), value: 'statistic', component: <StatisticOverview /> },
    { label: t(appStr.txt_067), value: 'assigned', component: <AssignedOverview /> },
  ]), [t]);

  const [currentTab, setCurrentTab] = useState(tabs[0].value);

  const handleTabsChange = useCallback((_, value) => {
    setCurrentTab(value);
  }, []);

  return (
    <PageSection title="Overview" rootRef={rootRef}>
      <Stack spacing={1}>
        <Typography color="text.primary" 
          sx={{fontSize: '1.1rem', fontWeight: 500}}>
          {t(appStr.txt_045)}
        </Typography>
        <>
          <Tabs
            indicatorColor="primary"
            onChange={handleTabsChange}
            scrollButtons="auto"
            textColor="primary"
            value={currentTab}
            variant="scrollable"
          >
            {tabs.map(({ label, value }) => (
              <Tab key={value} label={label} value={value} />
            ))}
          </Tabs>
          <Divider />
        </>
      </Stack>

      {/* Render Selected Tab Component */}
      {tabs.find(tab => tab.value === currentTab)?.component}
    </PageSection>
  );
};

export default Page;
